export const attribute = (l10n = {}, it = {}, data = {}) => {
    return `
    <section class="attribute">
        <header>
            <h3>${l10n['magicdoll.magicDollInfo']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            <ul>
                <li>
                    <div class="key">${l10n['common.option']}</div>
                    <div class="value">
                        ${it.buffBonusList?.map(({ displayValue, extra }) => {
                            const extraBonusTmpl = extra ? ` <em> ${extra} </em>` : ``;
                            return `<p>${displayValue}${extraBonusTmpl}</p>`;
                        }).join('') || ''}
                    </div>
                </li>

                ${!it.traits?.length ? ``:`
                <li>
                    <div class="key">${l10n['magicdoll.magicdollTrait']}</div>
                    <div class="value">
                        ${it.traits?.map(({ displayValue }) => `<p><em>${displayValue}</em></p>`).join('') || ''}
                    </div>
                </li>
                `}
            </ul>
        </article>
    </section>
    `
};
